import React from 'react';
import PartSitesCatalog from './partSitesCatalog/PartSitesCatalog';

const AccessoriesCatalogActivity = () => {
    return <PartSitesCatalog />;
};

export default AccessoriesCatalogActivity;
